export default __webpack_public_path__ + "static/media/munchimaps(cropped).8aac119e.png";